import {Injectable, Component} from '@angular/core';
import { BsModalService, BsModalRef} from 'ngx-bootstrap/modal';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-modal-message',
    template: `
    <div class="modal-header">
        <button type="button" class="close" (click)="bsModalRef.hide()">×</button>
        <h4 class="modal-title" translate>{{ title }}</h4>
    </div>

    <div class="modal-body">
        <div class="row-fluid">
              <span class="warning-icon-wrap">
                  <span class="ss-alert icon">&nbsp;</span>
              </span>
        </div>
        <div class="row-fluid text-center">
            <p>
                <span translate>{{ message }}</span>
            </p>
        </div>
    </div>

    <div class="modal-footer">
        <button class="btn" (click)="bsModalRef.hide()" translate>Close</button>
    </div>
    `
})

export class ModalMessageComponent {
    title = '';
    message = '';
    //type = '' //to handle 'success' | 'error' | 'info' | 'warning' icons
    constructor(public bsModalRef: BsModalRef) {} // Inject BsModalRef
}

@Injectable({ providedIn: 'root' })
export class ModalMessageService {

    constructor(private modalService: BsModalService,
                private translate: TranslateService
    ) {}

    show(message: string, title: string = 'Error', type: 'success' | 'error' | 'info' | 'warning' = 'error') {
        if(!message){
            console.log('ModalMessageService: Message is not set.');
            return;
        }
        if(!title){
            title = 'Error';
        }

        const initialState = {
            title: this.translate.instant(title),
            message: this.translate.instant(message),
            // type: type //to handle 'success' | 'error' | 'info' | 'warning' icons
        };
        this.modalService.show(ModalMessageComponent, {initialState});
    }
}

